// superadmin/pages/Dashboard.jsx

import Layout from "../layout/SuperAdminLayout";

function Dashboard({ adminEmail, onLogout }) {

  return (
    <Layout userName={adminEmail} onLogout={onLogout}>

      <div className="dash-page">

        <div className="dash-page-title">
          Super Admin Dashboard
        </div>

        <div className="dash-page-subtitle">
          Manage organisations and SaaS platform settings.
        </div>

        <div className="dash-card" style={{ marginTop: 24 }}>
          <p style={{ color: "var(--muted)", lineHeight: 1.7 }}>
            This dashboard will show platform statistics such as total organisations,
            active users, subscription plans, and system activity.
          </p>
        </div>

      </div>

    </Layout>
  );
}

export default Dashboard;